// 금천아 빌려줘 — 쇼핑몰 회원 가입 (2026-11-04)
//
// 카페24 가입 안내 메일을 10분 메일 점검이 저장한 목록(rental/services/signups.py).
// 주문 연결은 서버가 계산한다 — 아이디(주문 원본 member_id) 일치가 먼저, 아이디로 못 찾으면
// 주문자 이름 일치("이름만 일치" 표시). 메일에는 아이디·이름만 있다(이메일·연락처 없음).
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import api from "../../api";
import { formatDateTime } from "./format";
import "./rental.css";

export const PERIODS = [
  { key: "7", label: "최근 7일" },
  { key: "30", label: "최근 30일" },
  { key: "", label: "전체" },
];

/** 주문 칸 — 주문번호 링크 목록, 이름으로만 찾았으면 표시, 없으면 "주문 없음". */
export function OrderLinks({ row, onOpen }) {
  if (!row.orders.length) return <span className="rental-signup-none">주문 없음</span>;
  return (
    <span className="rental-signup-orders">
      {row.orders.map((o) => (
        <button key={o.id} type="button" className="rental-sales-link" onClick={() => onOpen(o.id)}>
          {o.order_id}
        </button>
      ))}
      {row.match === "name" && <span className="rental-sales-tag">이름만 일치</span>}
    </span>
  );
}

export default function RentalSignups() {
  const navigate = useNavigate();
  const [period, setPeriod] = useState("30");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let alive = true;
    setLoading(true);
    setError("");
    api
      .get("rental/signups/", { params: period ? { days: period } : {} })
      .then((res) => alive && setData(res.data))
      .catch((e) => alive && setError(e?.response?.data?.detail || "회원 가입 목록을 불러오지 못했습니다."))
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, [period]);

  const rows = data?.rows || [];
  const ordered = rows.filter((r) => r.orders.length).length;

  return (
    <div className="rental-page rental-signups">
      <div className="rental-header">
        <h2 className="rental-title">회원 가입</h2>
        <div className="rental-header-right">
          <button type="button" className="rental-btn-sync" onClick={() => navigate("/rental/orders")}>
            주문 목록
          </button>
        </div>
      </div>

      <div className="rental-tabs" role="group" aria-label="기간">
        {PERIODS.map((p) => (
          <button
            key={p.key || "all"}
            type="button"
            className={`rental-tab${period === p.key ? " rental-tab--active" : ""}`}
            onClick={() => setPeriod(p.key)}
          >
            {p.label}
          </button>
        ))}
      </div>

      {error && <div className="rental-error">{error}</div>}

      {loading ? (
        <div className="rental-empty">불러오는 중…</div>
      ) : rows.length === 0 ? (
        <div className="rental-empty">이 기간에 가입한 회원이 없습니다.</div>
      ) : (
        <>
          <div className="rental-signup-summary">
            가입 {rows.length}명 · 주문 있음 {ordered}명 · 주문 없음 {rows.length - ordered}명
          </div>
          <div className="rental-sales-table-wrap">
            <table className="rental-sales-table" aria-label="회원 가입 목록">
              <thead>
                <tr>
                  <th>가입일시</th>
                  <th>이름</th>
                  <th>아이디</th>
                  <th>주문</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.id}>
                    <td>{formatDateTime(r.signed_up_at)}</td>
                    <td>{r.name}</td>
                    <td>{r.member_id || "확인 불가"}</td>
                    <td>
                      <OrderLinks row={r} onOpen={(id) => navigate(`/rental/orders/${id}`)} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
